import { Add as AddIcon } from '@mui/icons-material';
import { CommonButton } from './CommonButton';

interface AddEnterpriseButtonProps {
  onAddClick: () => void;
}

export const AddEnterpriseButton = ({ onAddClick }: AddEnterpriseButtonProps) => {
  return (
    <CommonButton
      onClick={onAddClick}
      startIcon={<AddIcon />}
      sx={{ minWidth: 140 }}
    >
      기업 등록
    </CommonButton>
  );
}; 